import {
    FOOD_ROUTE,
    INFO_ROUTE,
    MAIN_ROUTE,
    ROOMS_ROUTE,
    TREATMENT_ROUTE
} from "./utils/consts";
import Main from "./pages/MainPage";
import TreatmentPage from "./pages/TreatmentPage";
import RoomsPage from "./pages/RoomsPage";
import FoodPage from "./pages/FoodPage";
import InfoPage from "./pages/InfoPage";
export const publicRoutes = [
    {
        path: MAIN_ROUTE,
        Component: Main
    },
    {
        path: TREATMENT_ROUTE,
        Component: TreatmentPage
    },
    {
        path: ROOMS_ROUTE,
        Component: RoomsPage
    },
    {
        path: FOOD_ROUTE,
        Component: FoodPage
    },
    {
        path: INFO_ROUTE,
        Component : InfoPage
    }
]